import { memo, useMemo } from "react";

import type { RefundRequestList_RefundRequestTopPageQuery } from "@/lib/gql/__generated__/graphql";

import { BlankContentForList } from "@/components/features/_components";
import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { Table, TableBody } from "@/components/ui/table/table";

import { ManagementRefundRequestTopTableBodyRow as Row } from "./body/row";
import { ManagementRefundRequestTopTableHeader as Header } from "./header";

type Props = {
	refundRequestList: RefundRequestList_RefundRequestTopPageQuery["refundRequestList"]["list"];
};

export const ManagementRefundRequestTopTable = memo(({ refundRequestList }: Props) => {
	/**
	 * 申請リストを表示できるか
	 */
	const canShowRefundRequestList = useMemo(() => refundRequestList.length > 0, [refundRequestList.length]);

	return (
		<FeatureIslandMainWithBackGround>
			{canShowRefundRequestList ? (
				<Table className="min-w-[900px]">
					<Header />

					<TableBody>
						{refundRequestList.map((item) => {
							return <Row key={item.uniqueID} row={item} />;
						})}
					</TableBody>
				</Table>
			) : (
				<BlankContentForList content="返金処理の申請履歴はありません。" />
			)}
		</FeatureIslandMainWithBackGround>
	);
});

ManagementRefundRequestTopTable.displayName = "ManagementRefundRequestTopTable";
